import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import * as crossUtils from '@daas-consulting/core-cross-utils';
import { interfaces } from '@daas-consulting/core-cross-interfaces';
import * as models from '@daas-consulting/production/remitos/frontend/models';
import { RemitosService } from '@daas-consulting/production/remitos/frontend/data_contracts';
import {
  Configuration,
  ConfigurationId,
} from '@daas-consulting/production/shared/cross/configuration';
import { Observable } from 'rxjs';

@Injectable()
export class HttpRemitosService implements RemitosService {
  readonly #http: HttpClient;
  readonly #baseUrl: string;

  constructor(
    http: HttpClient,
    @Inject(ConfigurationId) configuration: Configuration
  ) {
    this.#http = http;
    this.#baseUrl = `${configuration.baseUrl}/remitos`;
  }

  get$(remitoId: string): Observable<models.detailPreview.ItemView> {
    return this.#http.get<models.detailPreview.ItemView>(
      `${this.#baseUrl}/${remitoId}/detail-preview`
    );
  }

  getPrintData$(remitoId: string): Observable<models.print.PrintDataView> {
    return this.#http.get<models.print.PrintDataView>(
      `${this.#baseUrl}/${remitoId}/print-data`
    );
  }

  getAll$(
    criteria: interfaces.CriteriaRequest
  ): Observable<interfaces.PagedList<models.RemitoListItemModel>> {
    const params = crossUtils.criteria.mapCriteriaToParams(criteria);
    return this.#http.get<interfaces.PagedList<models.RemitoListItemModel>>(
      `${this.#baseUrl}/list`,
      { params }
    );
  }

  getFormData$(): Observable<models.FormData> {
    return this.#http.get<models.FormData>(`${this.#baseUrl}/form-data`);
  }

  save$(remito: models.RemitoFormModel): Observable<void> {
    return this.#http.post<void>(this.#baseUrl, remito);
  }

  getAvailablePrescriptions$(
    institutionId: string
  ): Observable<models.AvailablePrescriptionModel[]> {
    return this.#http.get<models.AvailablePrescriptionModel[]>(
      `${this.#baseUrl}/prescriptions?institutionId=${institutionId}`
    );
  }

  getActivePurchaseOrders$(
    institutionId: string
  ): Observable<models.PurchaseOrderFormData[]> {
    return this.#http.get<models.PurchaseOrderFormData[]>(
      `${this.#baseUrl}/purchase-orders?institutionId=${institutionId}`
    );
  }

  emit$(remitoId: string): Observable<void> {
    return this.#http.post<void>(`${this.#baseUrl}/${remitoId}/emit`, {});
  }

  cancel$(remitoId: string, reason: string): Observable<void> {
    return this.#http.post<void>(`${this.#baseUrl}/${remitoId}/cancel`, {
      reason,
    });
  }

  print$(remitoId: string): Observable<void> {
    return this.#http.post<void>(`${this.#baseUrl}/${remitoId}/print`, {});
  }
}
